import { Routes } from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  LocationOfDevicesUnrelatedToRoadOccupationDataSectionComponent
} from './sections/location-of-devices-unrelated-to-road-occupation-data-section/location-of-devices-unrelated-to-road-occupation-data-section.component';
import {
  PaymentsDataComponentConfig,
  PaymentsDataSectionComponent
} from '../common/payments-data-section/payments-data-section.component';

export const stages = [
  'Wnioskodawca',
  'Dane wniosku',
  'Zajęcia',
  'Prognozowane opłaty',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  successUrl: '../dane-zajecia',
  cancelUrl: '../wnioskodawca',
  addRoadTrafficImpactControl: true
};

export const paymentsDataSectionConfig: PaymentsDataComponentConfig = {
  stages,
  successUrl: '../zgody',
  cancelUrl: '../dane-zajecia'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../dane-zajecia',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const locationOfDevicesUnrelatedToRoadRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: LocationOfDevicesUnrelatedToRoadOccupationDataSectionComponent,
    path: ':appId/dane-zajecia'
  },
  {
    component: PaymentsDataSectionComponent,
    path: ':appId/oplaty',
    data: paymentsDataSectionConfig
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
